export const PLATFORM_TYPES = [
  { name: 'shopify', displayName: 'Shopify', id: '1' },
  { name: 'magento', displayName: 'Magento 1', id: '5' },
  { name: 'magento2', displayName: 'Magento 2', id: '31' },
  { name: 'bigcommerce', displayName: 'Bigcommerce', id: '3' },
  { name: 'woocommerce', displayName: 'Woocommerce', id: '12' },
  { name: 'volusion', displayName: 'Volusion', id: '6' },
  { name: 'commerce_cloud', displayName: 'Salesforce Commerce Cloud', id: '33' },
  { name: 'hybris', displayName: 'Hybris', id: '34' },
  { name: 'general', displayName: 'Other (Generic)', id: '2' }
];

export function getPlatformByKey(key, lookupValue) {
  let platform = PLATFORM_TYPES.find(pt => pt[key].toLowerCase() === lookupValue);
  return platform ? platform.name : undefined;
};
